import { FC } from 'react';
import BasicInfoOverlay from '@components/profile/profileOverlay/overlays/basicInfo';
import PreferOverlay from '@components/profile/profileOverlay/overlays/prefer';
import EduOverlay from '@components/profile/profileOverlay/overlays/edu';
import CareerOverlay from '@components/profile/profileOverlay/overlays/career';
import ProjectOverlay from '@components/profile/profileOverlay/overlays/project';
import SkillOverlay from '@components/profile/profileOverlay/overlays/skill';
import ExperienceOverlay from '@components/profile/profileOverlay/overlays/experience';
import PrizeOverlay from '@components/profile/profileOverlay/overlays/prize';
import MilitaryPreferenceOverlay from '@components/profile/profileOverlay/overlays/militaryPreference';
import AttachedFileOverlay from '@components/profile/profileOverlay/overlays/attachedFile';
import { ProfileOverlayType } from '@domain/constant/profile/ProfileOverlayType';

interface IProfileOverlay {
  overlayState: ProfileOverlayType;
  setOverlayState: (type: ProfileOverlayType) => void;
  openNHISModal: () => void;
}

const ProfileOverlay: FC<IProfileOverlay> = ({ overlayState, setOverlayState, openNHISModal }) => {
  const isVisible = (profileOverlayType: ProfileOverlayType) => profileOverlayType === overlayState;

  const onClose = () => {
    setOverlayState(null);
  };

  return (
    <>
      {/* 기본 정보 입력 */}
      <BasicInfoOverlay visible={isVisible('BASIC_INFO')} onClose={onClose} />
      {/* 선호 정보 입력 */}
      <PreferOverlay visible={isVisible('PREFER')} onClose={onClose} />
      {/* 학력 정보 입력 */}
      <EduOverlay visible={isVisible('EDU')} onClose={onClose} />
      {/* 경력 정보 입력 */}
      <CareerOverlay visible={isVisible('CAREER')} onClose={onClose} openNHISModal={openNHISModal} />
      {/* 프로젝트 입력 */}
      <ProjectOverlay visible={isVisible('PROJECT')} onClose={onClose} />
      {/* 지식 · 기술 입력 */}
      <SkillOverlay visible={isVisible('SKILL')} onClose={onClose} />
      {/* 경험 정보 입력 */}
      <ExperienceOverlay visible={isVisible('EXPERIENCE')} onClose={onClose} />
      {/* 수상 내역 입력 */}
      <PrizeOverlay visible={isVisible('PRIZE')} onClose={onClose} />
      {/* 병역 · 취업 우대 입력 */}
      <MilitaryPreferenceOverlay visible={isVisible('MILITARY_PREFERENCE')} onClose={onClose} />
      {/* 첨부 자료 입력 */}
      <AttachedFileOverlay visible={isVisible('ATTACHED_FILE')} onClose={onClose} />
    </>
  );
};

export default ProfileOverlay;
